'use client'
import React from 'react'

const Video = ({ height = '400', width = '1000', url, title, isMobile = false }) => {
    return (
        // <div className=''>
        <iframe
            width={width}
            height={height}
            src={url}
            title="Property Video"
            frameborder="0"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen={isMobile ? false : true}>

        </iframe>
        // </div>
    )
}

export default Video